import React, { useEffect, useState } from 'react';
import { URL } from '../api';
import axiosInstance from '../request';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { useNavigate } from "react-router-dom";

  const LoginFeeList = () => {
  const [payments, setPayments] = useState([]);
  const [filterType, setFilterType] = useState('');
  const [filterValue, setFilterValue] = useState('');
  const navigate = useNavigate();
  const [statusFilter, setStatusFilter] = useState('');

  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage] = useState(10);

  const fetchPayments = async () => {
    try {
      const params = new URLSearchParams();
      if (filterType && filterValue) {
  if (filterType === 'customerId') params.append('customerId', filterValue);
  if (filterType === 'razorpayOrderId') params.append('orderId', filterValue);
  if (filterType === 'razorpayPaymentId') params.append('paymentId', filterValue);
}

if (statusFilter) {
  params.append('status', statusFilter);
}

      const res = await axiosInstance.get(`${URL.LOGIN_FEE}?${params.toString()}`);
      setPayments(Array.isArray(res.data) ? res.data : []);
      setCurrentPage(1);
    } catch (error) {
      console.error('Error fetching payments:', error);
      setPayments([]);
    }
  };

  useEffect(() => {
    fetchPayments();
  }, []);

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      fetchPayments();
    }
  };

  // Pagination logic
  const totalPages = Math.ceil(payments.length / rowsPerPage);
  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = payments.slice(indexOfFirstRow, indexOfLastRow);

  // Export to Excel
  const exportToExcel = () => {
    const dataToExport = payments.map((p) => ({
      ID: p.id,
      CustomerID: p.customerId,
      CustomerName: p.customerName || '-',
      Amount: p.amount,
      Status: p.status,
      CreatedDate: p.createdDate ? p.createdDate.slice(0, 10) : '-',
      PaidDate: p.paidDate ? p.paidDate.slice(0, 10) : '-',
      PaymentLinkID: p.razorpayPaymentLinkId || '-',
      OrderID: p.razorpayOrderId || '-',
      PaymentID: p.razorpayPaymentId || '-',
    }));

    const worksheet = XLSX.utils.json_to_sheet(dataToExport);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'LoginFeePayments');

    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
    saveAs(blob, 'LoginFeePayments.xlsx');
  };

  return (
    <div className="container">
      <h3 className="mb-4">Login Fee Payments</h3>

      {/* Filter Section */}
      <div className="card mb-4 p-3">
        <div className="row gx-2 gy-2 align-items-end">
          <div className="col-auto">
            <label className="form-label">Filter Type</label>
            <select
  className="form-select form-select-sm"
  value={filterType}
  onChange={(e) => {
    setFilterType(e.target.value);
    setFilterValue('');
  }}
>
  <option value="">Select</option>
  <option value="customerId">Customer ID</option>
  <option value="razorpayOrderId">Razorpay Order ID</option>
  <option value="razorpayPaymentId">Razorpay Payment ID</option>
</select>
          </div>

          {filterType && (
  <div className="col-auto">
    <label className="form-label">
      {filterType === 'customerId'
        ? 'Customer ID'
        : filterType === 'razorpayOrderId'
        ? 'Order ID'
        : filterType === 'razorpayPaymentId'
        ? 'Payment ID'
        : 'Status'}
    </label>

    <input

      type="text"

      className="form-control form-control-sm"

      value={filterValue}

      onChange={(e) => setFilterValue(e.target.value)}

      onKeyDown={handleKeyDown}

    />

  </div>

)}

<div className="col-auto">
  <label className="form-label">Status</label>
  <select
    className="form-select form-select-sm"
    value={statusFilter}
    onChange={(e) => setStatusFilter(e.target.value)}
  >
    <option value="">All</option>
    <option value="pending">Pending</option>
    <option value="success">Success</option>
    <option value="failed">Failed</option>
  </select>
</div>
          <div className="col-auto">
            <button className="btn btn-sm btn-primary mt-1" onClick={fetchPayments}>
              Search
            </button>
          </div>

          <div className="col-auto">
            <button className="btn btn-sm btn-success mt-1" onClick={exportToExcel}>
              Export to Excel
            </button>
          </div>
          <div className="col-auto">
    <button
        className="btn btn-sm btn-warning mt-1"
        onClick={() => navigate("/LoginFeeMaster")}
    >
        Login Fee
    </button>
</div>
        </div>
      </div>

      {/* Table Section */}
      <div className="table-responsive">
        <table className="table table-sm table-bordered table-hover align-middle">
          <thead className="table-dark">
            <tr>
              <th className="text-nowrap">S.No.</th>
              <th className="text-nowrap">ID</th>
              <th className="text-nowrap">Customer ID</th>
              <th className="text-nowrap">Customer Name</th>
              <th className="text-nowrap">Amount</th>
              <th className="text-nowrap">Status</th>
              <th className="text-nowrap">Created Date</th>
              <th className="text-nowrap">Paid Date</th>
              <th className="text-nowrap">Payment Link ID</th>
              <th className="text-nowrap">Order ID</th>
              <th className="text-nowrap">Payment ID</th>
            </tr>
          </thead>
          <tbody>
            {Array.isArray(currentRows) && currentRows.length > 0 ? (
              currentRows.map((p, index) => (
                <tr key={p.id}>
                  <td className="text-nowrap">{indexOfFirstRow + index + 1}</td>
                  <td className="text-nowrap">{p.id}</td>
                  <td className="text-nowrap">{p.customerId}</td>
                  <td className="text-nowrap">{p.customerName || '-'}</td>
                  <td className="text-nowrap">₹{p.amount.toLocaleString()}</td>
                  <td className="text-nowrap">
                    <span
                      className={`badge rounded-pill ${
  p.status === 'SUCCESS'
    ? 'bg-success'
    : p.status === 'PENDING'
    ? 'bg-warning text-dark'
    : p.status === 'FAILED'
    ? 'bg-danger'
    : 'bg-secondary'
}`}
                    >
                      {p.status}
                    </span>
                  </td>
                  <td className="text-nowrap">{p.createdDate ? p.createdDate.slice(0, 10) : '-'}</td>
                  <td className="text-nowrap">{p.paidDate ? p.paidDate.slice(0, 10) : '-'}</td>
                  <td className="text-nowrap">{p.razorpayPaymentLinkId || '-'}</td>
                  <td className="text-nowrap">{p.razorpayOrderId || '-'}</td>
                  <td className="text-nowrap">{p.razorpayPaymentId || '-'}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="11" className="text-center text-muted">
                  No records found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Pagination Controls */}
      {payments.length > rowsPerPage && (
        <div className="d-flex justify-content-center mt-3">
          <div className="d-flex align-items-center overflow-auto" style={{ gap: "5px" }}>
            <button
              className="btn btn-sm btn-outline-primary"
              onClick={() => setCurrentPage((p) => Math.max(p - 1, 1))}
              disabled={currentPage === 1}
            >
              Prev
            </button>

            {Array.from({ length: totalPages }, (_, i) => (
              <button
                key={i + 1}
                className={`btn btn-sm ${currentPage === i + 1 ? "btn-primary" : "btn-outline-primary"}`}
                onClick={() => setCurrentPage(i + 1)}
              >
                {i + 1}
              </button>
            ))}

            <button
              className="btn btn-sm btn-outline-primary"
              onClick={() => setCurrentPage((p) => Math.min(p + 1, totalPages))}
              disabled={currentPage === totalPages}
            >
              Next
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default LoginFeeList;
